export const companiesEmits = ['update-status', 'companySelected', 'companyCheckbox', 'updateCompanyStatus', 'updateStatus'];